import { LoadingOverlay, MenuBar, Warning } from '../components';
import { InteractionStatus } from '@azure/msal-browser';
import { useReportingTech } from '../hooks';
import { useMsal } from '@azure/msal-react';
import { contactInfo } from '../config';

import type { FCC } from '../types';
import { useContext } from 'react';
import { Localization } from '../config/localization/localization';
import { LanguageSelectorContext } from '../context/LanguageSelectorContext';

export const PrivateLayout: FCC = ({ children }) => {
    const { hasReportingTech, reportingTech } = useReportingTech();
    const { inProgress } = useMsal();

    const { selectedLanguage } = useContext(LanguageSelectorContext);
    const localization = new Localization(selectedLanguage);

    return (
        <div className={'flex flex-col items-center justify-center'}>
            {/* MENU BAR */}
            <MenuBar />

            {/* PHONE/EMAIL INFORMATION */}
            {(!hasReportingTech || reportingTech?.clientCountryId) === 1 && (
                <Warning className={'w-full'}>
                    <p className={'whitespace-normal text-sm sm:text-base'}>
                        {localization.translate('phoneCallQuestion')}
                        <span
                            className={
                                'ml-1 whitespace-nowrap underline hover:text-gray-600 hover:opacity-75 dark:hover:text-gray-200'
                            }
                        >
                            <a href={`tel:${contactInfo.phone}`}>{contactInfo.phone}</a>
                        </span>
                        .
                    </p>
                </Warning>
            )}

            {/* DASHBOARD */}
            {hasReportingTech && (
                <div className={'flex w-full max-w-screen-2xl flex-col'}>
                    {inProgress === InteractionStatus.None && (
                        <div className={'min-h-screen w-full bg-gray-100 dark:bg-gray-dark-800'}>{children}</div>
                    )}
                </div>
            )}

            {/* LOADING OVERLAY */}
            {!hasReportingTech && (
                <div className={'h-full w-full'}>
                    <LoadingOverlay />
                </div>
            )}
        </div>
    );
};
